export default class RatingManager {

  constructor(options = {}) {

    this.selector = options.selector || ".rating";
    this.apiUrl = options.apiUrl || "/api/rating";
    this.maxStars = options.maxStars || 5;
    this.localStoragePrefix =  options.localStoragePrefix || "rating_";
    this.visitorCookie =  options.visitorCookie || "VisitorId";

    this.init();
  }

  init() {
    document.querySelectorAll(this.selector)
      .forEach(div => this.initializeRating(div));
  }

  initializeRating(container) {
    const pageId = container.dataset.pageid;
    const average = parseFloat(container.dataset.rating || 0);

    container.classList.add("rating-widget");
    const alreadyRated = this.hasRated(pageId);
    this.renderStars(container, average, alreadyRated);
  }

  renderStars(container, value, readonly) {

    container.innerHTML = "";
    for (let i = 1; i <= this.maxStars; i++) {
      const star = document.createElement("span");
      star.className = "rating-star";
      star.dataset.value = i;
      star.innerHTML = i <= Math.round(value) 
        ? "★"
        : "☆";

      if (!readonly) {
        star.classList.add("clickable");
        star.addEventListener("mouseenter", () =>
          this.preview(container, i));
        star.addEventListener("mouseleave", () =>
          this.renderStars(container, value, false));
        star.addEventListener("click", () =>
          this.submitRating(container, i));
      }

      container.appendChild(star);
    }

  }

  preview(container, value) {

    [...container.children].forEach((star, index) => {

      star.innerHTML = index < value
        ? "★"
        : "☆";

    });

  }

  hasRated(pageId) {
   return localStorage.getItem(this.localStoragePrefix + pageId) !== null;
  }

  async submitRating(container, rating) {

    const pageId = container.dataset.pageid;

    if (this.hasRated(pageId))
      return;

    localStorage.setItem(
      this.localStoragePrefix + pageId,
      rating
    );

    this.renderStars(container, rating, true);

    const payload = {
      pageId: pageId,
      rating: rating,
      visitorId: this.getCookie(this.visitorCookie)

    };

    try {
      const response = await fetch(this.apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok)
        throw new Error("Server error");

    }
    catch (e) {
      console.error(e);
      // Optional:
      // localStorage.removeItem(this.localStoragePrefix + pageId);
    }

  }

  getCookie(name) {

    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 2) return parts.pop().split(";").shift();
    return null;
  }

}
